import { i18n } from 'src/i18n';
import exporterRenders from 'src/modules/shared/exporter/exporterRenders';

export default [
  {
    name: 'id',
    label: i18n('entities.packagingCertification.fields.id'),
  },
  {
    name: 'name',
    label: i18n('entities.packagingCertification.fields.name'),
  },
  {
    name: 'logos',
    label: i18n('entities.packagingCertification.fields.logos'),
    render: exporterRenders.relationToMany(),
  },
  {
    name: 'infoMessage',
    label: i18n('entities.packagingCertification.fields.infoMessage'),
  },
  {
    name: 'createdAt',
    label: i18n('entities.packagingCertification.fields.createdAt'),
    render: exporterRenders.datetime(),
  },
  {
    name: 'updatedAt',
    label: i18n('entities.packagingCertification.fields.updatedAt'),
    render: exporterRenders.datetime(),
  },
];
